import { MantineProvider } from "@mantine/core";
import { ReportEditor } from "../../components/TiptapEditor/ReportEditor";
import { useReport } from "../../hooks/useReport";
import Loader from "../../components/AppLoader";
import { submitReport } from "../../api/report";
import { useAsyncFn } from "react-use";
import useTestId from "../../hooks/useTestId";
import useGraphsCapture from "../../hooks/useGraphsCapture";

export const ReportPage: React.FC = () => {
    const { html, logo, loading } = useReport({
        revalidateOnMount: true,
        revalidateIfStale: true,
    });
    const testId = useTestId();
    const { captureDataUrl, captureableElement } = useGraphsCapture();
    const initialContent = html
        ?.replace(
            /\{wasserman9_panel\}/,
            `<img width="600" src="${captureDataUrl}" alt="Graphs" />`
        )
        .replaceAll("{page_break}", '<div data-type="page-break"></div>');

    const [state, submit] = useAsyncFn(
        async (editor) => {
            const content = editor.getHTML();
            const report = {
                html: content,
                logo_base64: logo,
            };

            const response = await submitReport({
                testId: testId!,
                report,
            });

            return response;
        },
        [logo]
    );

    return (
        <div className="-m-3 xl:-m-5 overflow-hidden h-[calc(100vh-53px)] xl:h-[calc(100vh-80px)] flex flex-col">
            {!loading && captureDataUrl ? (
                <MantineProvider>
                    <ReportEditor
                        initialContent={initialContent}
                        onSubmit={submit}
                        isSubmitting={state.loading}
                    />
                </MantineProvider>
            ) : (
                <Loader />
            )}
            {captureableElement}
        </div>
    );
};
